import type { IArrowIcon } from './helpers';

export const ArrowIcon = ({ variant, ...rest }: IArrowIcon) => {
	if (variant === 'rightCaret') {
		return (
			<svg
				width='6'
				height='10'
				viewBox='0 0 6 10'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<path
					d='M3.78438 5.00048L0.484375 1.70048L1.42704 0.757812L5.66971 5.00048L1.42704 9.24315L0.484375 8.30048L3.78438 5.00048Z'
					fill='currentColor'
				/>
			</svg>
		);
	}
	if (variant === 'leftCaret') {
		return (
			<svg
				width='6'
				height='10'
				viewBox='0 0 6 10'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<path
					d='M2.22127 5.00048L5.52127 8.30048L4.5786 9.24315L0.335938 5.00048L4.5786 0.757812L5.52127 1.70048L2.22127 5.00048Z'
					fill='currentColor'
				/>
			</svg>
		);
	}
	if (variant === 'leftDoubleCaret') {
		return (
			<svg
				width='10'
				height='10'
				viewBox='0 0 10 10'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<path
					d='M4.5 5L7.5 8L6.557 8.943L2.614 5L6.557 1.057L7.5 2L4.5 5Z'
					fill='currentColor'
				/>
				<path
					d='M1.5 5L4.5 8L3.557 8.943L-0.386 5L3.557 1.057L4.5 2L1.5 5Z'
					fill='currentColor'
				/>
			</svg>
		);
	}
	if (variant === 'rightDoubleCaret') {
		return (
			<svg
				width='10'
				height='10'
				viewBox='0 0 10 10'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<path
					d='M5.5 5L2.5 2L3.443 1.057L7.386 5L3.443 8.943L2.5 8L5.5 5Z'
					fill='currentColor'
				/>
				<path
					d='M8.5 5L5.5 2L6.443 1.057L10.386 5L6.443 8.943L5.5 8L8.5 5Z'
					fill='currentColor'
				/>
			</svg>
		);
	}
	if (variant === 'bottomCaret') {
		return (
			<svg
				width='10'
				height='6'
				viewBox='0 0 10 6'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<path
					d='M5.00048 3.78047L8.30048 0.480469L9.24315 1.42314L5.00048 5.6658L0.757812 1.42314L1.70048 0.480469L5.00048 3.78047Z'
					fill='currentColor'
				/>
			</svg>
		);
	}
	if (variant === 'arrowDown') {
		return (
			<svg
				width='18'
				height='18'
				viewBox='0 0 18 18'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<path
					d='M8.99984 15.9373C8.85734 15.9373 8.71484 15.8848 8.60234 15.7723L4.04984 11.2198C3.83234 11.0023 3.83234 10.6423 4.04984 10.4248C4.26734 10.2073 4.62734 10.2073 4.84484 10.4248L8.99984 14.5798L13.1548 10.4248C13.3723 10.2073 13.7323 10.2073 13.9498 10.4248C14.1673 10.6423 14.1673 11.0023 13.9498 11.2198L9.39734 15.7723C9.28484 15.8848 9.14234 15.9373 8.99984 15.9373Z'
					fill='white'
				/>
				<path
					d='M9 15.81C8.6925 15.81 8.4375 15.555 8.4375 15.2475V2.625C8.4375 2.3175 8.6925 2.0625 9 2.0625C9.3075 2.0625 9.5625 2.3175 9.5625 2.625V15.2475C9.5625 15.555 9.3075 15.81 9 15.81Z'
					fill='white'
				/>
			</svg>
		);
	}
	if (variant === 'arrowLeft') {
		return (
			<svg
				width='18'
				height='18'
				viewBox='0 0 24 24'
				fill='none'
				stroke='currentColor'
				strokeWidth='1.8'
				strokeLinecap='round'
				strokeLinejoin='round'
				{...rest}
			>
				<path d='M19 12H5M5 12L12 5M5 12L12 19' />
			</svg>
		);
	}
	if (variant === 'arrowRight') {
		return (
			<svg
				width='18'
				height='18'
				viewBox='0 0 24 24'
				fill='none'
				stroke='currentColor'
				strokeWidth='1.8'
				strokeLinecap='round'
				strokeLinejoin='round'
				{...rest}
			>
				<path d='M5 12H19M19 12L12 5M19 12L12 19' />
			</svg>
		);
	}
	if (variant === 'arrowRight-available') {
		return (
			<svg
				width='18'
				height='18'
				viewBox='0 0 18 18'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<path
					d='M15.9375 9.00016C15.9375 9.14266 15.885 9.28516 15.7725 9.39766L11.22 13.9502C11.0025 14.1677 10.6425 14.1677 10.425 13.9502C10.2075 13.7327 10.2075 13.3727 10.425 13.1552L14.58 9.00016L10.425 4.84516C10.2075 4.62766 10.2075 4.26766 10.425 4.05016C10.6425 3.83266 11.0025 3.83266 11.22 4.05016L15.7725 8.60266C15.885 8.71516 15.9375 8.85766 15.9375 9.00016Z'
					fill='#CCCCCC'
				/>
				<path
					d='M15.81 9C15.81 9.3075 15.555 9.5625 15.2475 9.5625L2.625 9.5625C2.3175 9.5625 2.0625 9.3075 2.0625 9C2.0625 8.6925 2.3175 8.4375 2.625 8.4375L15.2475 8.4375C15.555 8.4375 15.81 8.6925 15.81 9Z'
					fill='#CCCCCC'
				/>
			</svg>
		);
	}
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			<g clipPath='url(#clip0_6952_45306)'>
				<path
					d='M13.4768 9.16591L9.00683 4.69591L10.1852 3.51758L16.6668 9.99924L10.1852 16.4809L9.00683 15.3026L13.4768 10.8326H3.3335V9.16591H13.4768Z'
					fill='#565F7D'
				/>
			</g>
			<defs>
				<clipPath id='clip0_6952_45306'>
					<rect
						width='20'
						height='20'
						fill='white'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};
